import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SHOW_STAGE_RESULTS } from '../../config/featureFlags';

const rightLink = {
  fontSize: 16,
  color: 'common.white',
  ml: 3,
};

function AppAppBar() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ flex: 1 }} />
          <Typography
            variant="h6"
            component="a"
            href="/chem-quiz/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            ХИМОЛИМПИАДА
          </Typography>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="inherit"
              href="/chem-quiz/sign-in/"
              sx={{ mx: 1 }}
            >
              Войти
            </Button>
            {SHOW_STAGE_RESULTS && (
            <div>
              <Button
                id="results-button"
                aria-controls={open ? 'results-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                color="inherit"
                sx={{ mx: 1 }}
              >
                Результаты отборочного этапа
              </Button>
              <Menu
                id="results-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'results-button' }}
              >
                <MenuItem component="a" href="/static/Protokol_Nanokhakaton_otborochny_etap.pdf" target="_blank" rel="noopener noreferrer">Протокол отборочного этапа</MenuItem>
                <MenuItem component="a" href="https://disk.yandex.ru/d/fompHSA98-b9nw" target="_blank" rel="noopener noreferrer">Сертификаты участников</MenuItem>
                <MenuItem component="a" href="https://disk.yandex.ru/d/1nptepTrHhKs8Q" target="_blank" rel="noopener noreferrer">Письма-приглашения финалистов</MenuItem>
              </Menu>
            </div>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;
